import { Form } from "react-bootstrap";
import Select from "react-select";
import { getSelectProps } from "utils/helperFunctions";

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  className?: string;
}

export default function TableSearchInput({ value, onChange, placeholder, className }: Readonly<Props>) {
  const { selectStyles, components } = getSelectProps();
  return (
    <Form.Group className={className}>
      <Select
        placeholder={placeholder}
        isClearable
        isSearchable
        components={components}
        inputValue={value}
        styles={selectStyles}
        menuIsOpen={false}
        onInputChange={(e, actionMeta) => {
          if (actionMeta.action === "input-change") onChange(e);
        }}
      />
    </Form.Group>
  );
}
